import React from 'react';

export const LabIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M9.5 3.5h5M10.75 3.5v5.4L5.9 16.9A2 2 0 0 0 7.6 20h8.8a2 2 0 0 0 1.7-3.1l-4.85-8V3.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LabIcon;
